import * as React from 'react';
import { css } from 'aphrodite/no-important';
import { CalculatedThumbnail } from '../image.types';
import { imageStyle, originalImageSize } from '../image.utils';
import { LARGE_SCREEN_SIZE, MEDIUM_SCREEN_SIZE, SMALL_SCREEN_SIZE } from '../../../../mediaQueries.const';

export const EagerImage: React.FunctionComponent<CalculatedThumbnail> = props => {
  const { fallbackSrc, alt, title, srcSetLargeScreen, srcSetMediumScreen, srcSetSmallScreen, aspectRatio } = props;
  const getImageStyle = css(imageStyle.base, aspectRatio?.original && aspectRatio.original === true ? originalImageSize.style : null);

  return (
    <picture className={getImageStyle}>
      <source srcSet={srcSetSmallScreen} media={`(max-width: ${SMALL_SCREEN_SIZE}px)`} />
      <source srcSet={srcSetMediumScreen} media={`(max-width: ${MEDIUM_SCREEN_SIZE}px)`} />
      <source srcSet={srcSetLargeScreen} media={`(min-width: ${LARGE_SCREEN_SIZE}px)`} />
      <img
        className={getImageStyle}
        src={fallbackSrc}
        alt={alt}
        title={title}
      />
    </picture>
  );
};
